<template>
    <modal size="max-w-md" :show="show" @close="close">
        <div class="card-title flex justify-between">
            <div>Добавить товары</div>
        </div>

        <form class="spaced-y-4" @submit.prevent="submit">
            <div class="flex -mx-2">
                <text-field class="w-full px-2" title="Количество" v-model="amount" required />
            </div>

            <hr class="mb-3" />

            <button class="btn btn-primary">Сохранить</button>
        </form>
    </modal>
</template>

<script>
export default {
    data() {
        return {
            amount: 1
        };
    },

    props: {
        show: Boolean,
        id: [Number, String]
    },

    methods: {
        submit() {
            axios
                .post("admin/products/" + this.id + "/add", {
                    amount: this.amount
                })
                .then(response => {
                    console.log(response.data);
                    this.$emit("success");
                    this.close();
                });
        },
        close() {
            this.$emit("update:show", false);
        }
    },

    mounted() {
        //
    }
};
</script>